import { render, staticRenderFns } from "./BusinessView.vue?vue&type=template&id=0deeee3b"
import script from "./BusinessView.vue?vue&type=script&lang=js"
export * from "./BusinessView.vue?vue&type=script&lang=js"
import style0 from "./BusinessView.vue?vue&type=style&index=0&id=0deeee3b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports